// vendor/get-document-master

import Api from "../utils/axios";

const masterApi = {
  getDocumentMaster: () => Api.get(`vendor/get-document-master`),
  getAllCountry: () => Api.get("master/get-all-country"),
  getAllCity: (countryId) => Api.get(`master/get-all-city/${countryId}`),
  getAllBuisnessType: () => Api.get("master/get-all-business-type"),
  getAllTax: () => Api.post("master/get-all-tax-master"),
  getDeliveryFeeById: (id) => Api.get(`master/get-delivery-fee-by-id/${id}`),

  getAllUnitMaster: () => Api.get(`master/get-all-units`),
  getUnitMasterBYId: (id) => Api.get(`master/get-unit/${id}`),

  saveFcmToken: (payload) => Api.post(`auth/create-fcm-token`, payload),
  getAllNotifications: (payload) => Api.post(`vendor/get-vendor-notification`, payload),
  markAllRead: () => Api.put(`vendor/mark-all-notifications-read`),
  markSingleRead: (id) => Api.put(`vendor/mark-notification-read/${id}`),
};

export default masterApi;
